export const arcDownloadFile = (fileURL: string, fileName: string) => {
  try {
    const a = document.createElement('a');
    a.href = fileURL;
    a.download = fileName;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    URL.revokeObjectURL(fileURL);
  } catch (e) {
    throw new Error('Invalid file');
  }
};
  